import Toaster from "../../../Toaster";
import FillBtn from "../../../Buttons/FillBtn";
import { Col, Container, Row } from "reactstrap";
import OutlineBtn from "../../../Buttons/OutlineBtn";
import { useDispatch, useSelector } from "react-redux";
import React, { memo, useCallback, useState } from "react";
import { setPractice } from "../../../../Redux/features/User/userSlice";
import axiosInstance from "../../../../Redux/interceptor";
import { DOCTOR_SELECT_PRACTICE_URL } from "../../../../utils/constants";

const SwitchPracticesForm = ({ toggle }) => {
  const dispatch = useDispatch();

  const { userPractices, user, loading } = useSelector((state) => state.user);

  const [selectedPractice, setSelectedPractice] = useState(
    user?.defaultPractice ?? null
  );

  const handlePracticeClick = useCallback((practice) => {
    setSelectedPractice(practice);
  }, []);

  const handleConfirmClick = useCallback(() => {
    if (selectedPractice?.id === user?.defaultPractice?.id) {
      Toaster.info("Practice already set");
    } else {
      if (selectedPractice) {
        // Logging failure must never block the switch.
        axiosInstance
          .post(DOCTOR_SELECT_PRACTICE_URL, {
            practiceId: selectedPractice.id,
            previousPracticeId: user?.defaultPractice?.id ?? null,
          })
          .catch(() => {});
        dispatch(setPractice(selectedPractice));
        Toaster.success("Practice set successfully");
        toggle();
      }
    }
  }, [dispatch, selectedPractice, toggle, user]);

  return (
    <Container>
      <Row>
        <Col className="d-flex align-items-center flex-column">
          <p className={"fs-3 text-custom-dark fw-bold"}>{"Select Practice"}</p>
        </Col>
      </Row>
      <Row className="d-flex justify-content-between gap-1">
        {userPractices?.map((practice) => {
          return (
            <Col
              md={5}
              className={`cursorPointer ${
                selectedPractice?.id === practice?.id
                  ? "activePracticeWrapper"
                  : "inactivePracticeWrapper"
              }`}
              onClick={() => handlePracticeClick(practice)}
            >
              <span>{practice?.name}</span>
            </Col>
          );
        })}
      </Row>
      <div className="d-flex justify-content-between w-100 gap-2 pt-4">
        <FillBtn
          className="w-100 py-2"
          text={"Confirm"}
          disabled={loading === "pending" ? true : false}
          handleOnClick={handleConfirmClick}
        />
        <OutlineBtn
          className="w-100 py-2"
          text={"Close"}
          handleOnClick={toggle}
          disabled={loading === "pending" ? true : false}
        />
      </div>
    </Container>
  );
};

export default memo(SwitchPracticesForm);
